import { FeatureCollection, MultiPolygon } from 'geojson';
import { Expression } from 'mapbox-gl';
import { Source, Layer } from 'react-map-gl';

export interface IlotBoundariesLayerProps {
  data: FeatureCollection<MultiPolygon, any>;
  id?: string;
  selectedIlotId?: number | null;
}

const ilotFillLayerStyle = {
  type: 'fill' as const,
  paint: {
    'fill-opacity': 0,
  },
};

export function IlotBoundariesLayer({
  data,
  id = 'ilot-boundaries',
  selectedIlotId,
}: IlotBoundariesLayerProps) {
  // Use expression to change color based on selection
  const outlineColorExpression: Expression =
    selectedIlotId !== undefined && selectedIlotId !== null
      ? [
          'case',
          ['==', ['get', 'id'], selectedIlotId],
          '#ffff00', // Yellow for selected
          '#ff0000', // Red for others
        ]
      : ['literal', '#ff0000']; // Default red wrapped as an expression

  return (
    <Source data={data} id={`${id}-source`} type="geojson">
      <Layer
        id={`${id}-fill`}
        {...ilotFillLayerStyle}
      />
      <Layer
        id={`${id}-outline`}
        type="line"
        paint={{
          'line-color': outlineColorExpression,
          'line-width': 4,
        }}
      />
    </Source>
  );
}

export default IlotBoundariesLayer;
